import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';
import OwlImage from './bkg-owl.png';

function Navbar() {
  const [click, setClick] = React.useState(false);
  const handleClick = () => setClick(!click);
  const close = () => setClick(false);

  const linkClass = ({ isActive }) =>
    isActive ? `${styles['nav-links']} ${styles['active']}` : styles['nav-links'];

  return (
    <nav className={styles['navbar']}>
      <div className={styles['navbar-container']}>
        <Link to="/" className={styles['navbar-brand']} onClick={close}>
          <span aria-hidden="true" className={styles['navbar-owl']} style={{ '--owl-src': `url(${OwlImage})` }} />
          <span className={styles['navbar-stack']}>
            <span className={styles['navbar-wordmark']}>
              Policy Pulse <span className={styles['navbar-accent']}>Institute</span>
            </span>
            <span className={styles['navbar-motto']}>
              P<span className={styles['motto-tail']}>rimum</span> N<span className={styles['motto-tail']}>on</span> D<span className={styles['motto-tail']}>esipere</span>
            </span>
          </span>
        </Link>

        <button
          type="button"
          className={styles['menu-icon']}
          aria-label="Menu"
          aria-expanded={click}
          onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </button>

        <ul className={click ? `${styles['nav-menu']} ${styles['active']}` : styles['nav-menu']}>
          <li className={styles['nav-item']}>
            <NavLink to="/" end className={linkClass} onClick={close}>Home</NavLink>
          </li>
          <li className={styles['nav-item']}>
            <NavLink to="/what-we-do" className={linkClass} onClick={close}>What We Do</NavLink>
          </li>
          <li className={styles['nav-item']}>
            <NavLink to="/about" className={linkClass} onClick={close}>Our Team</NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
